import * as React from 'react';

import * as styles from './overlayTextWrapper.scss';

interface Props {
    children?: React.ReactNode;
    className?: string;
}

const OverlayTextWrapper: React.FC<Props> = ({ children, className }) => {
    return (
        <div className={`${className} ${styles.textWrapper}`}>{children}</div>
    );
};

export default OverlayTextWrapper;
